import { Trans } from "@lingui/macro";

import { privacyPolicy } from "../../content/privacyPolicy";
import { useLocalize } from "../../content/useLocalize";
import { useGameStore } from "../../state/store";
import { Button } from "../common/Button";
import { Panel } from "../common/Panel";
import styles from "./PrivacyScreen.module.css";

export function PrivacyScreen(): JSX.Element {
  const t = useLocalize();
  const navigateTo = useGameStore((state) => state.navigateTo);
  const inGame = useGameStore((state) => state.inGame);

  return (
    <Panel title={<Trans>Политика конфиденциальности</Trans>}>
      <div className={styles.back}>
        <Button
          variant="ghost"
          size="small"
          onClick={() => navigateTo(inGame ? "settings" : "main_menu")}
        >
          {inGame ? <Trans>← К настройкам</Trans> : <Trans>← В главное меню</Trans>}
        </Button>
      </div>
      <p className={styles.updated}>
        <Trans>Обновлено</Trans>: {privacyPolicy.updated}
      </p>
      {privacyPolicy.sections.map((section) => (
        <section key={section.heading.en} className={styles.section}>
          <h3 className={styles.heading}>{t(section.heading)}</h3>
          {section.body.map((paragraph, index) => (
            <p key={index} className={styles.body}>
              {t(paragraph)}
            </p>
          ))}
        </section>
      ))}
    </Panel>
  );
}
